import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import moment from 'moment';

import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import utils from '../../../utils/validateScanner'
export default {
	name: 'auto-handover',
	mixins: [utils],
	components: {
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			
			checkedType:"directbagging",
			shippingid:"",
			currenthubid:"",
			currenthubname:"",
			createdBy:"",
			shippingIdErrorMSG:"",
			isInScan : false,
			inscanData:{},
			bagType:"",
			destination:"",
			bagNo:"",
			bagNoErrorMSG:"",
			scannedAwb:"",
			scannedAwbErrorMSG:"",
			isBagGenerated:false,
			bagGeneratedData:{},
			isLoading: false,
			isLoadingBag :false,
			isLoadingPrint:false,
			isAwbValidated:false,
			isBagValidated:false,
			disabled:0,
			group:"",
			showMultipartShipmentModal:false,
			multipartShipmentDetails:[],
			shipmentColor:"",
			BagForColor:""


		}
	},
	created: function() {},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.createdBy = userdetail[0].email;
		this.currenthubid  = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0];
		if(this.currenthubid > 0){
			this.getHubName(this.currenthubid);
		}
	},
	methods: {

		getHubName(hubid) {
			this.input = {
			  hubids: [hubid]
			}
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
				data: this.input,
				headers: {
				  'authorization': 'authkey xB84JJ89Hd25',
				}
			  })
			  .then(result => {
				if (result.data.ResultCode == 100) {
					this.currenthubname = result.data.ResponseData[0].HubName ;
				}
			  }, error => {
				console.error(error)
			  })
		  },
			
		checkField(){
			if(this.checkedType == 'bagging'){
			  this.$router.replace({ path: '/BaginProcess' });
			}
			else if(this.checkedType == 'sorterbagging'){
      this.$router.replace({path : '/SorterBagging'})
      }
	    },

	    inScan(){
			if (!this.shippingid ) {
				this.shippingIdErrorMSG = 'Enter Awb Number';
				return false;
			}
			this.isLoading = true;
			this.isInScan = false;
			this.isBagGenerated = false;
			this.isBagValidated = false;
			this.isAwbValidated = false;
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'validateAWB?shippingId='+ this.shippingid + '&currentHubId=' + this.currenthubid  + '&currentHubName='+ this.currenthubname + '&createdBy=' + this.createdBy ,
				headers: {
			  	'authorization': "authkey xB84JJ89Hd25",
			  	'requestfrom': "WEB",
				}
		  	})
		  	.then(result => {
				this.isLoading = false;
				this.shippingIdErrorMSG = '';
				if (result.data.ResultCode == 100) {
					if(Object.keys(result.data.lossCategorization).length !=0){
						this.shipmentColor = this.shippingid
						this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
					}
					this.isInScan = true;
					this.inscanData  = result.data.ResponseData;
					this.bagType = this.inscanData.bagtype;
					this.destination = this.inscanData.destinationhubname;
					this.group = this.inscanData.groupnameid ;
					}else if(result.data.ResultCode == 113){
						this.showMultipartShipmentModal=true
						this.multipartShipmentDetails = result.data.ResponseData.Result.PendingShipmentDetails
						this.$alertify.error("MPS pending for Inscan, check pending MPS list")
					}
				else {
			  	this.$alertify.error(result.data.ReturnMessage)
				}
		  	}, error =>
			  {
				console.error(error)
				this.isLoading = false
		 	})
        },
		closeMutlipartModal(){
				this.showMultipartShipmentModal =false;
				this.multipartShipmentDetails = [];
		},
		generateBagNo(){
			this.isLoadingBag = true;
			this.isBagGenerated = false;
			this.bagGeneratedData ={};
			this.bagNo ='';
			this.isBagValidated = false;
			this.isAwbValidated = false;
			this.input = ({
				shippingid: this.inscanData.shippingid,
				currentHubId: this.currenthubid,
				currentHubName: this.currenthubname,
				destinationHubId: this.inscanData.destinationhubid,
				destinationHubName: this.inscanData.destinationhubname,
				bagType: this.inscanData.bagtype,
				routeMode:this.inscanData.routemode,
				groupId:this.inscanData.groupid,
				connectionid:this.inscanData.connectionid,
                createdBy: this.createdBy,
                shipmentstatus:this.inscanData.status,
                statusMarkedFrom:"WEB",
                volumetricweight: this.inscanData.volumetricweight,
                physicalweight: this.inscanData.physicalweight,
                chargeableweight:this.inscanData.chargeableweight,
                clientid: this.inscanData.clientid,
                isManualEntry: false,
				multishipmentgroupid:this.inscanData.multishipmentgroupid,
				partialRtoflag:this.inscanData.partialRtoflag
			})

			axios({
				method: "POST",
				'url': apiUrl.api_url_hubops + 'generateDirectbag',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.isLoadingBag  = false;
				let response = result.data;
				if (response.ResultCode == 100 || response.ResultCode == 114) {
					this.$alertify.success(result.data.ReturnMessage)
					this.bagGeneratedData = result.data.ResponseData;
                    this.printerSticker();
					if (process.env.NODE_ENV !='production') {
						this.isBagGenerated = true;
					}
					this.disabled = 0;
					this.$nextTick(() => {
						this.$refs.bagNo.focus();
					})
				}else
				{
					this.$alertify.error(result.data.ReturnMessage);
				}
			}, error => {
				
				console.error(error);
				this.isLoadingBag = false;
			})


		},

		printerSticker() {
			this.isLoadingPrint =true;
			let prnData = '';
			if(this.inscanData.multishipmentgroupid){
				prnData = `^XA
				^SZ2^JMA
				^MCY^PMN
				^PW812
				~JSN
				~SD24^MD0
				^JZY
				^LH0,0^LRN
				^XZ
				^XA
				^FT305,44
				^CI0
				^A0N,34,46^FDXpressBees^FS
				^FO101,62
				^BY2^BCN,76,N,N^FD>:${this.bagGeneratedData.BagNo}^FS
				^FT178,170
				^A0N,34,46^FD${this.bagGeneratedData.BagNo}^FS
				^FO19,10
				^GB0,580,3^FS
				^FO19,587
				^GB774,0,3^FS
				^FO789,14
				^GB0,577,3^FS
				^FO17,187
				^GB775,0,3^FS
				^FO21,291
				^GB770,0,3^FS
				^FO19,387
				^GB772,0,3^FS
				^FO400,188
				^GB0,403,3^FS
				^FT56,222
				^A0N,34,30^FDOrigin -^FS
				^FT56,277
				^A0N,34,30^FD${this.currenthubname}^FS
				^FT56,328
				^A0N,34,30^FDDestination -^FS
				^FT56,377
				^A0N,34,30^FD${this.inscanData.destinationhubname}^FS
				^FT56,417
				^A0N,34,30^FDPDD -^FS
				^FT56,462
				^A0N,34,30^FD${this.inscanData.pdd}^FS
				^FT433,222
				^A0N,34,30^FDRoute -^FS
				^FT433,276
				^A0N,34,30^FD${this.inscanData.routemode}^FS
				^FT433,333
				^A0N,34,30^FDGroup ID -^FS
				^FT433,371
				^A0N,34,30^FD${this.inscanData.groupno}^FS
				^FT433,416
				^A0N,34,30^FDGroup Name -^FS
				^FT433,456
				^A0N,34,30^FD${this.inscanData.groupname}^FS
				^FT56,518
				^A0N,34,30^FDMPSGroupID -^FS
				^FT56,562
				^A0N,34,30^FD${this.inscanData.multishipmentgroupid}^FS
				^FO21,479
				^GB772,0,3^FS
				^FO21,10
				^GB772,0,3^FS
				^PQ1,0,1,Y
				^XZ`;
			}
			else{
			prnData=`^XA
			^SZ2^JMA
			^MCY^PMN
			^PW812
			~JSN
			~SD24^MD0
			^JZY
			^LH0,0^LRN
			^XZ
			^XA
			^FT305,44
			^CI0
			^A0N,34,46^FDXpressBees^FS
			^FO101,62
			^BY2^BCN,76,N,N^FD>:${this.bagGeneratedData.BagNo}^FS
			^FT178,170
			^A0N,34,46^FD${this.bagGeneratedData.BagNo}^FS
			^FO19,10
			^GB0,580,3^FS
			^FO19,587
			^GB774,0,3^FS
			^FO789,14
			^GB0,577,3^FS
			^FO17,187
			^GB775,0,3^FS
			^FO21,325
			^GB770,0,3^FS
			^FO19,461
			^GB772,0,3^FS
			^FO400,188
			^GB0,403,3^FS
			^FT43,240
			^A0N,34,46^FDOrigin -^FS
			^FT43,294
			^A0N,34,46^FD${this.currenthubname}^FS
			^FT43,370
			^A0N,34,46^FDDestination -^FS
			^FT43,420
			^A0N,34,46^FD${this.inscanData.destinationhubname}^FS
			^FT43,507
			^A0N,34,46^FDPDD -^FS
			^FT43,551
			^A0N,34,46^FD${this.inscanData.pdd}^FS
			^FT421,239
			^A0N,34,46^FDRoute -^FS
			^FT421,294
			^A0N,34,46^FD${this.inscanData.routemode}^FS
			^FT421,375
			^A0N,34,46^FDGroup ID -^FS
			^FT421,414
			^A0N,34,46^FD${this.inscanData.groupno}^FS
			^FT421,505
			^A0N,34,46^FDGroup Name -^FS
			^FT421,545
			^A0N,34,34^FD${this.inscanData.groupname}^FS
			^FO21,10
			^GB772,0,3^FS
			^PQ1,0,1,Y
			^XZ`;
		}
			this.input = {
			  // prnData:'I8,A\n'+
			  // 'ZN\n'+
			  // 'q812\n'+
			  // 'OD\n'+
			  // 'JF\n'+
			  // 'KIZZQ0\n'+
			  // 'KI9+0.0\n'+
			  // 'ZT\n'+
			  // 'Q609,B25\n'+
			  // 'Arglabel 762 31\n'+
			  // 'exit\n'+
			  // 'N\n'+
			  // 'X36,22,3,776,583\n'+
			  // 'LO33,370,738,3\n'+
			  // 'LO35,146,736,3\n'+
			  // 'LO406,23,3,347\n'+
			  // 'A763,356,2,1,2,2,N,"'+"Origin -"+'"\n'+
			  // 'A396,356,2,1,2,2,N,"'+"Route -" +'"\n'+
			  // 'A764,242,2,1,2,2,N,"'+"Destination -"+'"\n'+
			  // 'A395,242,2,1,2,2,N,"'+"Group ID -"+'"\n'+
			  // 'B666,519,2,1,3,6,102,N,"'+this.bagGeneratedData.BagNo+'"\n'+
			  // 'A589,411,2,1,2,2,N,"'+this.bagGeneratedData.BagNo+'"\n'+
			  // 'A763,318,2,1,2,2,N,"'+this.currenthubname+'"\n'+
			  // 'A397,322,2,1,2,2,N,"'+this.inscanData.routemode+'"\n'+
			  // 'A765,206,2,1,2,2,N,"'+this.inscanData.destinationhubname+'"\n'+
			  // 'A394,208,2,1,2,2,N,"'+this.inscanData.groupno+'"\n'+
			  // 'A506,564,2,1,2,2,N,"'+"XpressBees"+'"\n'+
			  // 'LO37,258,736,3'+'\n'+
			  // 'A763,133,2,1,2,2,N,"'+"PDD -"+'"\n'+
			  // 'A394,131,2,1,2,2,N,"'+"Group Name -"+'"\n'+
			  // 'A764,97,2,1,2,2,N,"'+this.inscanData.pdd +'"\n'+
			  // 'A393,97,2,1,2,2,N,"'+this.inscanData.groupname+'"\n'+
			  // 'P1\n'
				prnData: prnData,
				bagNumber: moment().format('DD-MM-YYYY')
			}
			axios({
				method: "POST",
				url: "http://localhost:4500/printer/printbagsticker",
				data: this.input,
			  })
			  .then(result => {
				this.isLoadingPrint = false;
				if (result.data.ResultCode == 100) {
				  this.$alertify.success(result.data.ReturnMessage);
				  if(process.env.NODE_ENV=='production'){
				  		this.isBagGenerated = true;
				  }
				} else {
				  this.$alertify.error(result.data.ReturnMessage);
				}
			  }, error => {
				this.isLoadingPrint = false;
				var code = error.response == undefined ? code = 0 : error.response.status;
				if (code == 500) {
				  this.$alertify.error("Printer API error");
				  console.log(error.response.statusText);
				} else if (error) {
				  this.$alertify.error("Printer not connected")
				}
			  })
		  },


		validateBag(bagNo){
			if (!bagNo) {
				this.bagNoErrorMSG = 'Enter Bag Number to Validate';
				return false;
			}
			this.isLoadingBag = true;
			this.isBagValidated = false;
			this.isAwbValidated = false;
			this.scannedAwb ='';
			this.disabled = 0;
			axios({	
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'validateDirectBagging?bagNumber='+ bagNo + '&currentHubId=' + this.currenthubid +'&awbNumber='+ this.bagGeneratedData.ShippingID,
				headers: {
			  	'authorization': "authkey xB84JJ89Hd25",
			  	'requestfrom': "WEB",
				}
		  	})
		  	.then(result => {
				this.isLoadingBag  = false;
				this.bagNoErrorMSG = '';
				if (result.data.ResultCode == 100) {
					this.isBagValidated = true;
					this.$alertify.success(result.data.ReturnMessage, "", "success");
					if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
                       this.colorCodeBag = result.data.lossCategorization.colorCode;
                       this.colorIconBag = result.data.lossCategorization.icon;
                    }

					this.$nextTick(() => {
						this.$refs.scannedAwb.focus();
					})
				}
				else {
			  	this.$alertify.error(result.data.ReturnMessage)
				}
		  	}, error => 
			  {
				console.error(error);
				this.isLoadingBag  = false;
		 	})

		},

		validateShipment(shipment){
			this.isLoadingBag = true;
			this.isAwbValidated = false;
			
			if(!shipment){
				this.scannedAwbErrorMSG = 'Please enter shipping id to validate';
			}

			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'getDirectbaggingShipment?bagNumber='+ this.bagNo + '&shippingId=' + shipment + '&statusMarkedFrom=WEB' ,
				headers: {
			  	'authorization': "authkey xB84JJ89Hd25",
			  	'requestfrom': "WEB",
				}
		  	})
		  	.then(result => {
				this.scannedAwbErrorMSG='';
				this.isLoadingBag  = false;
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage, "", "success");
					this.isAwbValidated = true;
					this.disabled = 1;
				}
				else {
			  	this.$alertify.error(result.data.ReturnMessage)
				}
		  	}, error => 
			  {
				console.error(error);
				this.isLoadingBag = false;
		 	})

		},

		closeBag(){
			this.isLoadingBag  = true;

		  this.input = ({
				bagNumber:this.bagNo,
				hubId: this.currenthubid,
				hubName: this.currenthubname,
				createdBy: this.createdBy,
				statusMarkedFrom: "WEB"
			  })
			

			axios({
				method: 'PUT',
				'url':apiUrl.api_url_hubops + 'closeDirectbaggingBag',
				'data': this.input,
				headers: {
				  'authorization': 'authkey xB84JJ89Hd25',
				}
			  })
			  .then(result => {
				this.isLoadingBag = false;
				if (result.data.ResultCode == 100) {
				if(result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0){
                this.BagForColor = this.bagNo;
                this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
              }
				  this.$alertify.success('Bag Close Successfully', "", "success");
				  this.reset();
				}else{
				  this.$alertify.error(result.data.ReturnMessage);
				}
			  }, error => {
				console.error(error);
				this.isLoadingBag = false;

			  })

	    },


		reset() {
			this.shippingid = "";
			this.inscanData =[];
			this.bagType = "";
			this.destination = "";
			this.isInScan = false;
			this.shippingIdErrorMSG="";
			this.bagNo="";
			this.bagNoErrorMSG = "";
			this.scannedAwb= "";
			this.scannedAwbErrorMSG="";
			this.isInScan = false;
			this.isBagGenerated=false;
			this.isLoadingBag  = false;
			this.isLoading = false;
			this.isLoadingPrint =true;
			this.isBagValidated = false;
			this.isAwbValidated = false;
			this.showHideCodeIconInput();
			
		}
            

			

	}

}




// WEBPACK FOOTER //
// ./src/views/components/DirectBagging/DirectBagging.js